import { useQuery } from '@tanstack/react-query';
import apiClient from '../api-client';

export type ContestRulesResponse = {
  rules: {
    id: string;
    title: string;
    version?: string;
    rules_text: string;
  } | null;
  message?: string;
};

export const getContestRules = (contestId: string) =>
  apiClient.get<ContestRulesResponse>(`/api/squares/${contestId}/rules`);

export const useGetContestRulesQuery = (contestId: string | null) => {
  return useQuery({
    queryKey: ['contestRules', contestId],
    queryFn: () => getContestRules(contestId!),
    select: data => data.rules,
    enabled: !!contestId,
  });
};
